import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    // apikey: "0800b6dcf9bebecefc7894ed0096c39d", // image-processing
    apikey: "f42146e35d93327bdd96191e521bb306", // Nemesis Integration
    store: {},
    toast: { "active": false, "content": "", "error": false }
}

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setStore: (state, action = {}) => {
            state.store = action.payload ?? {}
        },
        setToast: (state, action = {}) => {
            state.toast = action.payload ?? { "active": false, "content": "", "error": false }
        },
    },
})

export const { setStore, setToast } = appSlice.actions

export default appSlice.reducer